import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActiveCartService, AuthRedirectService, I18nModule } from 'haba-core';
import { CheckoutLoginComponent } from 'haba-featurelibs/checkout/components';
import { HabaProLoginFormComponent } from '../../authentication/haba-login-form/haba-login-form.component';

@Component({
  selector: 'app-checkout-login',
  templateUrl: './haba-checkout-login.component.html',
  styleUrls: ['./haba-checkout-login.component.scss'],
  imports: [HabaProLoginFormComponent, I18nModule],
})
export class HabaCheckoutLoginComponent extends CheckoutLoginComponent {
  redirectAfterLogin = 'checkout/review-order';

  constructor(
    formBuilder: FormBuilder,
    authRedirectService: AuthRedirectService,
    activeCartService: ActiveCartService
  ) {
    super(formBuilder, authRedirectService, activeCartService);
  }
}
